import React from 'react';
type Testimonial = {
  name: string;
  role: string;
  location: string;
  quote: string;
  initials: string;
  color: string;
};
const testimonials: Testimonial[] = [{
  name: 'Katrin S.',
  role: 'Vinyasa-Lehrerin',
  location: 'Hamburg, Deutschland',
  quote: 'Ich habe meine Wochenenden zurück. Früher habe ich Stunden auf Pinterest verbracht – jetzt öffne ich das Kit und habe Sequenz und Thema fertig. Meine Schüler lieben die neuen Klassen.',
  initials: 'KS',
  color: '#8B6FBF'
}, {
  name: 'Michael B.',
  role: 'Studio-Inhaber',
  location: 'München, Deutschland',
  quote: 'Die therapeutischen Karten sind pures Gold. Sie gaben mir die Sicherheit, Schüler mit Bandscheibenvorfällen oder Nackenproblemen professionell zu betreuen. Ich improvisiere nicht mehr, ich habe einen Plan.',
  initials: 'MB',
  color: '#D4A574'
}, {
  name: 'Sarah L.',
  role: 'Freelance-Lehrerin',
  location: 'Berlin, Deutschland',
  quote: 'Es ist viel mehr als ein PDF. Es ist ein komplettes pädagogisches System. Ich unterrichte seit 7 Jahren und dieses Kit hat unglaubliche Frische in meine Praxis gebracht.',
  initials: 'SL',
  color: '#0F8B6F'
}, {
  name: 'Julia R.',
  role: 'Hatha Yoga-Lehrerin',
  location: 'Köln, Deutschland',
  quote: 'Die 52 philosophischen Intentionen geben jeder Klasse eine ganz andere Seele. Meine Schüler sagen, sie gehen verwandelt aus der Stunde, nicht nur „trainiert".',
  initials: 'JR',
  color: '#D98AA8'
}, {
  name: 'Anna B.',
  role: 'Therapeutisches Yoga',
  location: 'Frankfurt, Deutschland',
  quote: 'Die Protokolle für Ü60 und Menopause waren eine Offenbarung. Endlich habe ich eine seriöse Referenz für meine Schüler mit spezifischen Bedürfnissen.',
  initials: 'AB',
  color: '#8B6FBF'
}, {
  name: 'Lena M.',
  role: 'Vinyasa Flow-Lehrerin',
  location: 'Stuttgart, Deutschland',
  quote: 'Das Übergangs-Handbuch hat meine Art zu unterrichten verändert. Meine Flows laufen jetzt wie ein Tanz, ohne „Löcher" zwischen den Posen.',
  initials: 'LM',
  color: '#D4A574'
}];
export function TestimonialsSection() {
  return <section id="testimonials" className="w-full bg-bg-main py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-258">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-primary/8 rounded-full blur-[120px] pointer-events-none hidden sm:block" data-id="element-259"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-260">
        <div className="text-center mb-10 sm:mb-14" data-id="element-261">
          <p className="text-primary font-bold uppercase tracking-wider text-xs sm:text-sm mb-3" data-id="element-262">
            ⭐ Echte Erfahrungsberichte
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-263">
            Was deutsche Yoga-Lehrer <span className="text-primary" data-id="element-264">sagen</span>
            .
          </h2>
          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-265">
            <span className="text-[#E0A52E] text-base sm:text-lg" data-id="element-266">
              ⭐⭐⭐⭐⭐
            </span>
            <span className="text-text-sec text-sm sm:text-base font-medium" data-id="element-267">
              4.9/5 (+800 verifizierte Bewertungen)
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-268">
          {testimonials.map((t, i) => <article key={i} className="bg-bg-alt border border-border-light rounded-2xl p-6 sm:p-7 shadow-[0_8px_24px_-12px_rgba(90,70,120,0.15)] flex flex-col relative" data-id="element-269">
              <span aria-hidden="true" className="absolute top-3 right-5 text-5xl font-black text-primary/15 leading-none select-none" data-id="element-270">
                "
              </span>

              <div className="text-[#E0A52E] text-sm mb-3" data-id="element-271">⭐⭐⭐⭐⭐</div>

              <p className="text-text-main text-[15px] sm:text-base leading-relaxed font-medium mb-5 flex-grow" data-id="element-272">
                {t.quote}
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-273">
                <div className="w-11 h-11 rounded-full flex items-center justify-center text-white font-black text-sm flex-shrink-0" style={{
              backgroundColor: t.color
            }} aria-hidden="true" data-id="element-274">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-275">
                  <p className="text-text-main font-bold text-sm truncate" data-id="element-276">
                    {t.name}
                  </p>
                  <p className="text-text-sec text-xs truncate" data-id="element-277">{t.role}</p>
                  <p className="text-text-sec text-xs truncate" data-id="element-278">
                    📍 {t.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <p className="text-center text-text-sec text-sm sm:text-base font-medium mt-10 sm:mt-12" data-id="element-279">
          Über <span className="text-primary font-bold" data-id="element-280">15.000 Lehrer</span>{' '}
          weltweit unterrichten bereits mit YOGA-BEREIT.
        </p>
      </div>
    </section>;
}